import { render } from "./px-avatar-set.vue?vue&type=template&id=be6a778e&scoped=true&ts=true"
import script from "./px-avatar-set.vue?vue&type=script&lang=ts"
export * from "./px-avatar-set.vue?vue&type=script&lang=ts"

import "./px-avatar-set.vue?vue&type=style&index=0&id=be6a778e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be6a778e"]])

export default __exports__